import { Directive, Input, OnChanges, Self, SimpleChanges } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '([formControlName], [formControl])[disabledControl]',
})
export class DisabledControlDirective implements OnChanges {
  @Input() disabledControl = false;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['disabledControl']) {
      const action = this.disabledControl ? 'disable' : 'enable';
      if (this.ngControl?.control) {
        this.ngControl.control[action]();
      }
    }
  }

  constructor(@Self() private readonly ngControl: NgControl) {}
}
